export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getNavigationItems(state) {
      return state.items;
    },
    ANALISTA(state) {
      let modo = state.items.some((i) => {
        return i.permissao == "analise";
      });
      return modo ? true : false;
    },
    VENDEDOR(state) {
      let modo = state.items.some((i) => {
        return i.permissao == "vendas";
      });
      return modo ? true : false;
    },
  },
  mutations: {
    setNavigationItems(state, payload) {
      state.items = payload;
    },
  },
  actions: {},
};
